/**
 * Event publishability rules for the Download documents gate.
 *
 * Mirrors the backend FulfilmentEvent::PUBLISHED_EVENT_STATES constant
 * (app/models/fulfilment_event.rb). Keep in sync when that list changes.
 */

/** Event statuses that are considered publishable (can produce event-order documents). */
export const PUBLISHABLE_EVENT_STATUSES = [
  'confirmed',
  'preparing',
  'ready',
  'delivered',
] as const;

/** Returns true when the given event status is publishable. */
export function isEventPublishable(status: string): boolean {
  return (PUBLISHABLE_EVENT_STATUSES as readonly string[]).includes(status);
}
